// src/components/header/HeaderUpgradeCard.tsx
// UPDATED: Default destination changed to /upgrade (prototype upgrade page)

import React from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";

interface HeaderUpgradeCardProps {
  destination?: string;
}

export default function HeaderUpgradeCard({ 
  destination = "/upgrade"  // CHANGED: from "/freemium/upgrade" to "/upgrade"
}: HeaderUpgradeCardProps) {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(destination)}
      className="
        inline-flex items-center gap-2 rounded-xl border-2 border-[#FF6E4C] 
        bg-gradient-to-r from-[#FF6E4C] to-[#FF8C70] 
        px-4 py-2 text-xs font-bold text-white shadow-sm 
        transition-all duration-300
        hover:shadow-lg hover:shadow-orange-500/50 hover:scale-105
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#FF6E4C]
      "
      aria-label="Upgrade to DVA Pro"
      title="Upgrade to DVA Pro"
    >
      <Sparkles className="w-3.5 h-3.5" />
      Upgrade to DVA Pro
    </button>
  );
}